var styles = {
raw: ".hcr-autocomplete-13-6-1{position:relative}.hcr-autocomplete__list-box-13-6-1{left:0;position:absolute;right:0;translate:0 var(--hcr-spacing-1);z-index:10}",
map:{"hcr-autocomplete":"hcr-autocomplete-13-6-1","hcr-autocomplete__list-box":"hcr-autocomplete__list-box-13-6-1"}};

export { styles as default };
